import { ValidationRule } from './validation.rule';

export class ValidationResult {
  failedRules: ValidationRule[] = [];

  get success(): boolean {
    return this.failedRules.length == 0;
  }

  failed(rule: ValidationRule): void {
    this.failedRules.push(rule);
  }
}
